import { TextField } from '../../forms/FormikFields';
import { LimitedStringValidation } from '../../forms/utils';
import { FIELD_STUDENTID, REQUIRED_STUDENT_VALUES } from '../constants';
function EnterStudentId(_ref) {
  var isCurrentYear = _ref.isCurrentYear,
    disabled = _ref.disabled;
  if (isCurrentYear) {
    return /*#__PURE__*/React.createElement(TextField, {
      label: "Student ID",
      placeholder: "Enter your Student ID",
      description: "If you have a student identifier or student ID number issued by your state, district, or school enter it here. You may enter up to 25 characters. Do not enter your social security number in this field.",
      maxLength: 25,
      name: FIELD_STUDENTID,
      validate: function validate(value) {
        return LimitedStringValidation(value);
      },
      autocomplete: "off",
      required: REQUIRED_STUDENT_VALUES[FIELD_STUDENTID],
      disabled: disabled
    });
  }
  return null;
}
export default EnterStudentId;